import moment from "moment";

export const isOver13 = (birthDate: any) => {
	return moment().diff(moment.utc(birthDate, "YYYY-MM-DD"), "years") >= 13;
};
